var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { getOwner } from '@ember/application';
import Service, { inject as service } from '@ember/service';
import * as Sentry from '@sentry/browser';
let EmberMultipassLoggingService = (_dec = service('ember-multipass-config'), _class = class EmberMultipassLoggingService extends Service {
  get canLog() {
    return !this.multipassConfig.isProduction;
  }
  constructor(properties) {
    super(properties);
    _initializerDefineProperty(this, "cookies", _descriptor, this);
    _initializerDefineProperty(this, "multipassConfig", _descriptor2, this);
    _defineProperty(this, "sentryClient", void 0);
    _defineProperty(this, "scope", void 0);
    const config = getOwner(this).resolveRegistration('config:environment');

    // Initialize Sentry
    let sentryDsn = '';
    if (this.multipassConfig.isProduction) {
      sentryDsn = config['ember-multipass-components'].sentry.dsn_production;
    } else if (this.multipassConfig.isStaging) {
      sentryDsn = config['ember-multipass-components'].sentry.dsn_staging;
    }
    this.sentryClient = new Sentry.BrowserClient({
      dsn: sentryDsn
    });
    this.scope = new Sentry.Scope();
    this.scope.setUser({
      id: this.cookies.read('_savt') || null
    });
    this.scope.setTags({
      manually_captured: true
    });
  }
  log(...args) {
    if (!this.canLog) {
      return;
    }
    console.log(...args);
  }
  error(...args) {
    if (!this.canLog) {
      return;
    }
    console.error(...args);
  }
  sentryMessage(message, severity) {
    this.updateScope();
    this.sentryClient.captureMessage(message, severity ?? Sentry.Severity.Warning, undefined, this.scope);
  }
  sentryError(error) {
    this.updateScope();
    this.sentryClient.captureException(error, undefined, this.scope);
  }
  updateScope() {
    this.scope.setExtra('hostname', window.location.hostname);
    this.scope.setExtra('pathname', window.location.pathname);
  }
  addFeatureFlagTag(flagName, flagValue) {
    this.scope.setTag(flagName, flagValue);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "cookies", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "multipassConfig", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { EmberMultipassLoggingService as default };